import { setActiveChatMessagesAction } from '@/redux/chat/actions'
import { fetchMessages, FetchMessagesResponse } from '@/redux/chat/sagas/_http/chat'
import { put } from 'redux-saga/effects'
import { fetchMoreMessagesAsync, setHasMoreMessages } from '../../actions'

const MESSAGES_LIMIT = 50

export function* fetchMoreMessagesSaga(action: ReturnType<typeof fetchMoreMessagesAsync.request>) {
  try {
    const { lastMessage, chatId, ownerId } = action.payload
    const startAfter = lastMessage?.createdAt || lastMessage?.moment || lastMessage?.momment
    const { messages, hasMore }: FetchMessagesResponse = yield fetchMessages({
      chatId,
      ownerId,
      startAfter,
      queryLimit: MESSAGES_LIMIT
    })

    yield put(setActiveChatMessagesAction(messages))
    yield put(setHasMoreMessages({ state: hasMore }))
  } catch (error) {
    yield put(fetchMoreMessagesAsync.failure(error))
  }
}
